const setEquals = <T>(a: Set<T>, b: Set<T>) =>
  a.size === b.size && Array.from(a).every((value) => b.has(value));
export { setEquals };
